// import React, { useState } from 'react';
// import './LatestOrder.css';

// const LatestOrder = ({ MainName, status, OrderId, OrderDate, Cost, orderdatespan, onAccept, onRefuse,onComplted }) => {
//   // State to manage the dropdown visibility
//   const [isDropdownVisible, setDropdownVisible] = useState(false);

//   // Determine the border color based on the status
//   const getStatusBorderColor = () => {
//     if (status === 'completed') return '#009B10';
//     if (status === 'ongoing' || status === 'inprocess') return '#FF9900';
//     return 'gray'; // Default border color
//   };
  
//   const getStatusColor = () => {
//     if (status === 'completed') return '#009B10';
//     if (status === 'ongoing' || status === 'inprocess') return '#FF9900';
//     return 'gray'; // Default border color
//   };

//   // Handle Accept click
//   const handleAccept = () => {
//     onAccept(OrderId); // Call the parent API function
//     setDropdownVisible(false); // Close the dropdown after action
//   };
// const handleComplted = ()=>{
//   onComplted(OrderId); // Call the parent API function
//   setDropdownVisible(false); // Close the dropdown after action
// }
//   // Handle Refuse click
//   const handleRefuse = () => {
//     onRefuse(OrderId); // Call the parent API function
//     setDropdownVisible(false); // Close the dropdown after action
//   };

//   // Determine what dropdown options to show
//   const getDropdownContent = () => {
//     if (status === 'ongoing') {
//       return (
//         <>
//           <button className="dropdown-item text-[0.6em] pb-1 font-[#7FFFD]" onClick={handleAccept}>Accept</button>
//           <button className="dropdown-item text-[0.6em]" onClick={handleRefuse}>Refuse</button>
//         </>
//       );
//     }

//     if (status === 'inprocess') {
//       return (
//         <button onClick={handleComplted} className="dropdown-item text-[0.6em]" >
//           Completed
//         </button>
//       );
//     }

//     // If the status is 'completed', no dropdown is shown.
//     return null;
//   };

//   return (
//     <div className="latestOrder">
//       <div className="main-div-latest-order">
//         <div>
//           <h5 className="heading-h5-later">{MainName || 'Harry Makfee'}</h5>
//         </div>
//         {status === 'ongoing' || status === 'inprocess' ? (
//           <div className="div-btn-button" style={{ border: `1px solid ${getStatusBorderColor()}` }}>
//             <button 
//               className="btn-main-later" 
//               style={{ color: `${getStatusColor()}` }} 
//               onClick={() => setDropdownVisible(!isDropdownVisible)}
//             >
//               {status}
//             </button>
//             {isDropdownVisible && (
//               <div className="dropdown text-center">
//                 {getDropdownContent()}
//               </div>
//             )}
//           </div>
//         ) : status === 'completed' ? (
//           <div className="div-btn-button" style={{ border: `1px solid ${getStatusBorderColor()}` }}>
//             <button className="btn-main-later" style={{ color: `${getStatusColor()}` }}>
//               Completed
//             </button>
//           </div>
//         ) : null}
//       </div>
//       <div className="main-div-latest-order" style={{ marginTop: 15, marginBottom: 2 }}>
//         <div className="div-order-inner">
//           <p className="paragph-heading">Order ID:</p>
//           <h5 className="heading-h5-later">{OrderId}</h5>
//         </div>
//         <div className="div-order-inner">
//           <p className="paragph-heading">Order Date:</p>
//           <h5 className="heading-h5-later">
//             {OrderDate}{' '}
//             {orderdatespan && <span style={{ fontSize: 9 }}>AED</span>}
//           </h5>
//         </div>
//         <div className="div-order-inner">
//           <p className="paragph-heading">Cost:</p>
//           <h5 className="heading-h5-later">{Cost} AED </h5>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default LatestOrder;

import React, { useState } from 'react';
import './LatestOrder.css';
import { IoIosArrowDown } from "react-icons/io";

const LatestOrder = ({ MainName, status, OrderId, OrderDate, Cost, orderdatespan, onAccept, onRefuse, onComplted,Item }) => {
  const [isDropdownVisible, setDropdownVisible] = useState(false);
console.log(Item,'ItemaLatest Order')
  const getStatusBorderColor = () => {
    if (status === 'completed') return '#009B10';
    if (status === 'ongoing' || status === 'inprocess') return '#FF9900';
    return 'gray';
  };

  const getStatusColor = () => {
    if (status === 'completed') return '#009B10';
    if (status === 'ongoing' || status === 'inprocess') return '#FF9900';
    return 'gray';
  };

  const handleAccept = () => {
    onAccept(OrderId);
    setDropdownVisible(false);
  };

  const handleRefuse = () => {
    onRefuse(OrderId);
    setDropdownVisible(false);
  };

  const handleComplted = () => {
    onComplted(OrderId);
    setDropdownVisible(false);
  };

  return (
    <div className="latestOrder">
      <div className="main-div-latest-order">
        <div>
          <h5 className="heading-h5-later">{MainName || 'Harry Makfee'}</h5>
        </div>
        {Item?.isExpired && (
    <h5 className="paragprh-customer-com  text-red-600 bg-red-100 px-2 py-1 rounded-full mr-[-12px]">
      Expired
    </h5>
  )}
  {Item?.isExpired === false && (
     <div>
        {status === 'ongoing' || status === 'inprocess' ? (
          <div className="div-btn-button" style={{ border: `1px solid ${getStatusBorderColor()}` }}>
            <button 
              className="btn-main-later flex items-center gap-1 text-[11px]" 
              style={{ color: getStatusColor(), display: 'flex', alignItems: 'center',paddingBottom:'0px', }} 
              onClick={() => setDropdownVisible(!isDropdownVisible)}
            >
              {status === 'ongoing' ? 'New Order' : 'In Process'}
              <IoIosArrowDown style={{fontSize:15}} />

            </button>

            {isDropdownVisible && (
              <div className="dropdown text-center p-[5px] overflow-hidden">
                {status === 'ongoing' && (
                  <>
                  <button 
  className="block w-full text-[10px] rounded-[5px]  text-[#009b10] px-1 py-1 text-center hover:text-[#747EEF]"
  onClick={handleAccept}
  style={{ color: '#009b10',border:'1px solid #009b10'}}
>
  Accept
</button>

<button
  className="block w-full  text-[10px] rounded-[5px]  text-[#bb2124] px-1 py-1 text-center hover:text-[#747EEF]"
  onClick={handleRefuse}
  style={{ color: '#bb2124',border:'1px solid #bb2124',marginTop:'2px'}}
>
  Refuse
</button>

                  </>
                )}
                {status === 'inprocess' && (
                  <button
                    onClick={handleComplted}
                    className="block w-full text-[10px] rounded-[5px]  px-1 py-1 text-center hover:text-[#747EEF]"
                    style={{ color: '#009b10',border:'1px solid #009b10'}}
                  >
                    Completed
                  </button>
                )}
              </div>
            )}
          </div>
        ) : status === 'completed' ? (
          <div className="div-btn-button p-[0px] overflow-hidden" style={{ border: `1px solid ${getStatusBorderColor()}` }}>
            <button className="btn-main-later" style={{ color: getStatusColor() }}>
              Completed
            </button>
          </div>
        ) : null}
      </div> 
  )}

</div>
      <div className="main-div-latest-order" style={{ marginTop: 15, marginBottom: 2 }}>
        <div className="div-order-inner">
          <p className="paragph-heading">Order ID:</p>
          <h5 className="heading-h5-later">{OrderId}</h5>
        </div>
        <div className="div-order-inner">
          <p className="paragph-heading">Order Date:</p>
          <h5 className="heading-h5-later">
            {OrderDate} {orderdatespan && <span style={{ fontSize: 9 }}>AED</span>}
          </h5>
        </div>
        <div className="div-order-inner">
          <p className="paragph-heading">Cost:</p>
          <h5 className="heading-h5-later">{Cost} AED</h5>
        </div>
      </div>
    </div>
  );
};

export default LatestOrder;
